import { render } from "./TetotepitekBanner.vue?vue&type=template&id=7a958f23&scoped=true"
import script from "./TetotepitekBanner.vue?vue&type=script&lang=js"
export * from "./TetotepitekBanner.vue?vue&type=script&lang=js"

import "./TetotepitekBanner.vue?vue&type=style&index=0&id=7a958f23&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a958f23"]])

export default __exports__